import { IndividualConfig } from 'ngx-toastr';

export class NotificationMessage {
  title?: string;
  message: string;
  eventId?: any;
  isBusinessError?: boolean;
  options?: Partial<IndividualConfig>;

  constructor(
    customMessage?: string,
    eventId?: number,
    isBusinessError?: boolean,
  ) {
    this.message = customMessage;
    this.eventId = eventId;
    this.isBusinessError = isBusinessError;
  }
}
